var _path, _polygon, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProcessing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M418.1,228.6a70.5,70.5,0,1,1,101.11,1.53l35.48,34.64a119.17,119.17,0,1,0-169-1.1Z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M692.17,336.9s-6.51-2.82-11.14,12.4S675.14,373,675.14,373s-1.35,3.26-3.7,1.71-6.06-6.48-9.3-4.9-3.82,5.8-2.11,11.48,5,18.27,5.28,19.41-.06,2.91-1.83,2.11-12.64-9.29-16.35-3.89,3.64,20.45,4.42,22.11.56,2.46-.19,3-4.14-2.61-7.32-4.9-7.29-4.38-9.18-1.08-.53,15.33,14.24,32.64l7.37,7.57,10.33-2.44c21.79-6.56,29.44-15.95,29.64-19.73s-4.38-4.25-8.3-4.06-8.49,1-8.81.16-.06-1.68,1.49-2.66,15.89-9.65,15.68-16.2-13.93-5.3-15.85-5.58-1.25-2-.4-2.76,10.44-9.61,15-13.46,6.38-7.6,4.44-10.8-7.66-.95-10.47-.92-2.19-3.43-2.19-3.43,3.55-7.85,7.9-23.15S692,336.85,692,336.85",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688,350.52s0,.11-.08.32l-.25,1c-.23.84-.56,2.06-1,3.62-.87,3.15-2.17,7.7-3.78,13.31-3.24,11.22-7.84,26.68-13,43.74s-9.77,32.52-13.07,43.73c-1.64,5.59-3,10.12-3.89,13.27l-1.07,3.6-.28.94c-.07.21-.11.31-.11.31s0-.11.07-.32.15-.54.25-.95c.24-.84.57-2.06,1-3.62.87-3.15,2.16-7.7,3.78-13.31,3.24-11.22,7.84-26.68,13-43.75s9.77-32.51,13.07-43.71l3.89-13.28c.46-1.55.82-2.76,1.06-3.6.13-.4.22-.71.29-.94S688,350.52,688,350.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.06,376.94a3.54,3.54,0,0,1,.39.66c.23.43.55,1.07.94,1.86.77,1.57,1.78,3.78,2.84,6.24s2,4.61,2.7,6.3c.32.75.6,1.38.82,1.9a2.51,2.51,0,0,1,.27.72,3.13,3.13,0,0,1-.39-.66c-.24-.43-.56-1.06-.94-1.86-.75-1.58-1.73-3.8-2.79-6.26s-2-4.59-2.74-6.28l-.84-1.9A2.52,2.52,0,0,1,667.06,376.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676,394.63c0-.09,4.42-2.37,10-5.08s10.07-4.86,10.11-4.77-4.41,2.37-10,5.09S676.06,394.72,676,394.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.94,420.48a3.53,3.53,0,0,1,.76-.18l2.09-.37c1.76-.31,4.19-.75,6.86-1.33s5.06-1.18,6.8-1.63l2-.53a4.06,4.06,0,0,1,.77-.16,3.08,3.08,0,0,1-.73.29c-.47.17-1.17.39-2,.64-1.71.52-4.11,1.16-6.78,1.74s-5.13,1-6.9,1.24c-.89.12-1.61.21-2.11.25A2.89,2.89,0,0,1,666.94,420.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.32,406.27s.2.16.51.5.76.84,1.31,1.46c1.09,1.25,2.57,3,4.2,4.92s3.07,3.7,4.11,5c.52.65.94,1.17,1.22,1.54a3.29,3.29,0,0,1,.41.6,3,3,0,0,1-.52-.51c-.31-.34-.76-.84-1.3-1.46-1.09-1.25-2.58-3-4.2-4.92s-3.08-3.7-4.12-5c-.52-.64-.93-1.17-1.21-1.54A3.22,3.22,0,0,1,655.32,406.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.41,428.07a3.83,3.83,0,0,1,.65.65l1.68,1.87c1.4,1.59,3.32,3.81,5.43,6.27s4,4.7,5.35,6.33c.63.78,1.16,1.43,1.59,1.94a4.86,4.86,0,0,1,.54.75,4.4,4.4,0,0,1-.65-.65l-1.68-1.88c-1.4-1.59-3.32-3.8-5.43-6.26s-4-4.7-5.35-6.33L645,428.81A4.89,4.89,0,0,1,644.41,428.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.41,445.35a5.54,5.54,0,0,1,1-.25l2.63-.56c2.22-.48,5.29-1.14,8.65-2s6.39-1.65,8.58-2.26l2.59-.72a5.79,5.79,0,0,1,1-.23,6,6,0,0,1-.93.36c-.6.21-1.47.5-2.56.83-2.17.68-5.19,1.54-8.56,2.37s-6.45,1.46-8.69,1.87c-1.11.2-2,.36-2.65.45A4.21,4.21,0,0,1,659.41,445.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.41,
    y: 376.78,
    width: 130.1,
    height: 60,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.42,434h-124v-54h124Zm-123.22-.81H384.61v-52.4H262.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.51,
    y: 376.78,
    width: 31.78,
    height: 60,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.79,396.65H385a.17.17,0,0,0,0-.33H261.79a.17.17,0,0,0,0,.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.8,396.49a136.38,136.38,0,0,0,.05-16.3.17.17,0,0,0-.34,0,136.38,136.38,0,0,0,.05,16.3.12.12,0,1,0,.24,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357,388.34a1.68,1.68,0,1,1-1.68-1.68A1.68,1.68,0,0,1,357,388.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.3,388.34a1.68,1.68,0,1,1-1.67-1.68A1.68,1.68,0,0,1,292.3,388.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.08,406.94a1.68,1.68,0,1,1-1.68-1.68A1.68,1.68,0,0,1,325.08,406.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.96 436.78 267.26 474.45 271.03 474.45 283.38 436.78 273.96 436.78",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.31 436.78 384.91 474.51 381.14 474.51 369.89 436.78 379.31 436.78",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.46 436.78 410.81 474.51 407.04 474.51 395.04 436.78 404.46 436.78",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,423.92a1.68,1.68,0,1,1-1.68-1.68A1.68,1.68,0,0,1,325,423.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.79,415.23H385a.17.17,0,0,0,0-.33H261.79a.17.17,0,0,0,0,.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 580.39,
    y: 84.81,
    width: 82.26,
    height: 110.32,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 584.67,
    y: 89.15,
    width: 73.69,
    height: 101.65,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 608.55,
    y: 124.31,
    width: 28.13,
    height: 32.15,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 635.94,
    y: 212.18,
    width: 53.42,
    height: 71.65,
    transform: "translate(414.64 910.64) rotate(-90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 629.64,
    y: 224.07,
    width: 66.01,
    height: 47.86,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 653.78,
    y: 236.85,
    width: 18.27,
    height: 20.88,
    transform: "translate(415.63 910.2) rotate(-90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.4,
    y: 127.42,
    width: 52.19,
    height: 70,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.12,
    y: 130.17,
    width: 46.76,
    height: 64.5,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.27,
    y: 152.48,
    width: 17.85,
    height: 20.4,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.9 342.68 340.34 375.69 385.92 375.69 389.7 342.68 343.9 342.68",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "345.77 345.05 342.31 373.94 383.44 373.94 386.77 345.05 345.77 345.05",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.69 349.91 350.56 369.08 376.52 369.08 377.85 349.91 352.69 349.91",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "388.07 356.9 397.48 375.82 385.92 375.69 388.21 355.66",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M680.63,474.26c0,.14-140.88.26-314.61.26s-314.65-.12-314.65-.26S192.22,474,366,474,680.63,474.12,680.63,474.26Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Loading--inject-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 133.67,
    y: 77.41,
    width: 376.27,
    height: 247.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.94,325.09c0-1.7-.08-96.6-.21-247.68l.21.21-376.24,0h0l.26-.26c0,88.11,0,172,0,247.68l-.24-.24,376.27.24-376.27.23h-.24v-.23c0-75.73,0-159.57,0-247.68v-.26h.29l376.24.06h.2v.2C510,228.49,509.94,323.4,509.94,325.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.94,99.45c0,.14-84.24.26-188.13.26s-188.14-.12-188.14-.26,84.22-.26,188.14-.26S509.94,99.31,509.94,99.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.73,
    y: 136.09,
    width: 315.44,
    height: 43.17,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.33,
    y: 254.76,
    width: 70.03,
    height: 70.03,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.11,
    y: 254.76,
    width: 70.03,
    height: 70.03,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.42,
    y: 254.76,
    width: 70.03,
    height: 70.03,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.55,225.08H212.64a11.57,11.57,0,0,1-11.57-11.56h0A11.57,11.57,0,0,1,212.64,202h75.91a11.57,11.57,0,0,1,11.57,11.57h0A11.57,11.57,0,0,1,288.55,225.08Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.29,225.08l1-.07c.35,0,.76-.12,1.26-.2a11.55,11.55,0,0,0,8.94-9,11.63,11.63,0,0,0-1.34-8.08,11.45,11.45,0,0,0-7.92-5.5,42.21,42.21,0,0,0-5.57-.17h-6l-13,0-142.11.08a11.3,11.3,0,0,0-.75,22.58c1.61.08,3.28,0,4.91,0h37.73l63.89.06,43.07.08,11.71.05,3,0,1,0-1,0-3,0-11.71.05-43.07.08-63.89,0-37.73,0c-1.64,0-3.26,0-4.94,0a11.82,11.82,0,0,1-4.85-1.38,11.83,11.83,0,0,1,5.63-22.23l142.11.07,13,0h6a38.55,38.55,0,0,1,5.62.2,11.69,11.69,0,0,1,9.41,13.9,11.9,11.9,0,0,1-3.23,5.89,11.69,11.69,0,0,1-4.19,2.63,12.93,12.93,0,0,1-1.7.48c-.51.07-.93.15-1.27.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276,233.17h.87l-1.06,5.29h3.28l-.15.75h-4.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.75,237.29a2.61,2.61,0,0,1,2.69-2.7,1.93,1.93,0,0,1,2.14,2,2.61,2.61,0,0,1-2.68,2.71A2,2,0,0,1,279.75,237.29Zm4-.68a1.2,1.2,0,0,0-1.36-1.29,1.8,1.8,0,0,0-1.79,1.93,1.21,1.21,0,0,0,1.36,1.29A1.79,1.79,0,0,0,283.74,236.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.45,234.64l-.9,4.57h-.8l.11-.56a2.25,2.25,0,0,1-1.61.62,1.89,1.89,0,0,1-2-2,2.56,2.56,0,0,1,2.59-2.7,1.74,1.74,0,0,1,1.65.82l.15-.77Zm-1.23,2a1.21,1.21,0,0,0-1.37-1.29,1.8,1.8,0,0,0-1.78,1.93,1.21,1.21,0,0,0,1.36,1.29A1.79,1.79,0,0,0,289.22,236.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.71,232.81l-1.28,6.4h-.79l.11-.56a2.29,2.29,0,0,1-1.62.62,1.89,1.89,0,0,1-2-2,2.57,2.57,0,0,1,2.59-2.7,1.75,1.75,0,0,1,1.66.83l.52-2.61Zm-1.61,3.8a1.2,1.2,0,0,0-1.36-1.29,1.8,1.8,0,0,0-1.79,1.93,1.21,1.21,0,0,0,1.37,1.29A1.79,1.79,0,0,0,295.1,236.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.91,234.64h.83l-.9,4.57H297Zm.14-1.38a.57.57,0,0,1,.6-.58.5.5,0,0,1,.52.48.58.58,0,0,1-.6.6A.51.51,0,0,1,298.05,233.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.32,236.11a3.5,3.5,0,0,1-.05.54l-.51,2.56h-.83l.51-2.56a2.9,2.9,0,0,0,0-.38c0-.6-.34-.93-1.06-.93a1.61,1.61,0,0,0-1.69,1.46l-.49,2.41h-.83l.91-4.57h.8l-.12.58a2.28,2.28,0,0,1,1.66-.63A1.46,1.46,0,0,1,304.32,236.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.6,234.64l-.78,4a2.51,2.51,0,0,1-2.74,2.35,3.18,3.18,0,0,1-2.09-.65l.46-.63a2.57,2.57,0,0,0,1.69.55,1.63,1.63,0,0,0,1.82-1.49l.07-.33a2.32,2.32,0,0,1-1.66.63,1.83,1.83,0,0,1-2-1.86,2.52,2.52,0,0,1,2.61-2.57,1.79,1.79,0,0,1,1.71.89l.17-.84Zm-1.27,1.86c0-.73-.5-1.18-1.36-1.18a1.73,1.73,0,0,0-1.8,1.79c0,.74.51,1.19,1.37,1.19A1.73,1.73,0,0,0,309.33,236.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.31,238.71a.6.6,0,0,1,.61-.63.54.54,0,0,1,.54.56.6.6,0,0,1-.6.63A.55.55,0,0,1,313.31,238.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.27,238.71a.6.6,0,0,1,.61-.63.54.54,0,0,1,.54.56.6.6,0,0,1-.6.63A.55.55,0,0,1,315.27,238.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.22,238.71a.61.61,0,0,1,.62-.63.54.54,0,0,1,.54.56.6.6,0,0,1-.6.63A.56.56,0,0,1,317.22,238.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,89.5a2.76,2.76,0,1,1-2.76-2.76A2.76,2.76,0,0,1,148,89.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.76,89.5A2.76,2.76,0,1,1,157,86.74,2.76,2.76,0,0,1,159.76,89.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.48,89.5a2.76,2.76,0,1,1-2.75-2.76A2.76,2.76,0,0,1,171.48,89.5Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 470.72,
    cy: 182.76,
    r: 131.32,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602,182.76s0-.72-.08-2.13c0-.71-.05-1.58-.08-2.62s0-2.26-.18-3.62-.23-2.91-.37-4.59-.44-3.53-.69-5.52a136.85,136.85,0,0,0-2.66-13.6,132.9,132.9,0,0,0-5.38-16.49,125.73,125.73,0,0,0-9.14-18.48,132.68,132.68,0,0,0-33.32-37.29,130.81,130.81,0,0,0-55.22-24.5,133.06,133.06,0,0,0-51.38.59A129.07,129.07,0,0,0,409,67.13a137.28,137.28,0,0,0-16.15,10.23,130.52,130.52,0,0,0-27.74,27.85,129.58,129.58,0,0,0-10.69,17.2c-.75,1.53-1.61,3-2.28,4.59L350,131.68c-1.27,3.19-2.57,6.39-3.62,9.69a128.22,128.22,0,0,0-5,20.27,142.42,142.42,0,0,0-1.72,21.1,142.31,142.31,0,0,0,1.71,21.1,129.57,129.57,0,0,0,5,20.29l.84,2.45.41,1.23.47,1.2q1,2.42,1.9,4.81l2.12,4.68c.67,1.57,1.53,3.06,2.28,4.59a129.7,129.7,0,0,0,10.69,17.21A141.52,141.52,0,0,0,378,275.41a143.13,143.13,0,0,0,14.79,12.75A140.05,140.05,0,0,0,409,298.39,137.45,137.45,0,0,0,426,306a138.93,138.93,0,0,0,17.53,5,133,133,0,0,0,51.38.59,130.86,130.86,0,0,0,55.21-24.51,132.57,132.57,0,0,0,33.33-37.29,126.63,126.63,0,0,0,9.13-18.48A130.2,130.2,0,0,0,598,214.83c1.24-5.07,2.11-9.62,2.67-13.6.24-2,.51-3.82.69-5.51s.25-3.22.36-4.59.16-2.58.18-3.62.06-1.92.08-2.62c0-1.41.08-2.13.08-2.13s0,.72,0,2.13c0,.7,0,1.58-.06,2.62s0,2.26-.16,3.63-.21,2.9-.34,4.59-.42,3.53-.66,5.52a135.89,135.89,0,0,1-2.63,13.63,129,129,0,0,1-5.34,16.53A125.92,125.92,0,0,1,583.72,250a132.9,132.9,0,0,1-33.35,37.43A130.92,130.92,0,0,1,495,312a133.76,133.76,0,0,1-51.56-.55,129.26,129.26,0,0,1-34.72-12.65,138.83,138.83,0,0,1-16.22-10.26,144.27,144.27,0,0,1-14.86-12.79,142.64,142.64,0,0,1-13-15.17,130.14,130.14,0,0,1-10.74-17.28c-.75-1.53-1.61-3-2.29-4.6l-2.13-4.7c-.63-1.61-1.26-3.21-1.9-4.82l-.48-1.21-.41-1.23-.84-2.47a128.11,128.11,0,0,1-5-20.37,130.89,130.89,0,0,1,0-42.36,128,128,0,0,1,5-20.36c1.05-3.31,2.36-6.51,3.63-9.72l2.13-4.7c.68-1.58,1.54-3.07,2.29-4.6a129.39,129.39,0,0,1,10.74-17.27,140.52,140.52,0,0,1,13-15.17A144.06,144.06,0,0,1,392.51,77,137.52,137.52,0,0,1,408.73,66.7a129.26,129.26,0,0,1,34.72-12.65A133.3,133.3,0,0,1,495,53.49a131.25,131.25,0,0,1,55.36,24.64,132.74,132.74,0,0,1,33.35,37.43,126.52,126.52,0,0,1,9.12,18.54,129.46,129.46,0,0,1,5.34,16.53c1.23,5.08,2.08,9.65,2.63,13.63.24,2,.5,3.83.66,5.52s.24,3.23.34,4.6S602,177,602,178s0,1.92.06,2.63C602,182,602,182.76,602,182.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-4)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M418.1,228.6a70.5,70.5,0,1,1,101.11,1.53l35.48,34.64a119.17,119.17,0,1,0-169-1.1Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M533.08,179.62h64.09s-6.48,52.17-7.78,53.14-39.21,44.72-39.21,44.72l-43.1-51.2Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "515.79 136.47 561.14 91.95 593.07 139.59 597.33 179.62 533.85 179.62 522.29 154.17 515.79 136.47"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M473.51,120.32c-.77-1.3,0-64.16,0-64.16l39.08,4.91,48.12,31.06-46.23,45.36-29.11-4.21Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M380.42,94.4c1,.32,43.1,45.36,43.1,45.36l37.59-14.9,12.06-15,.34-53.66-44.8,4.91Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M347.33,179.62c1,.65,71.29,0,71.29,0l-1.24-46.28-33.94-36-23.15,27.52Z"
  })))), /*#__PURE__*/React.createElement("circle", {
    cx: 472.05,
    cy: 182.76,
    r: 27.36,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464,184.59h0a7.76,7.76,0,0,0,9.57,5.29l95.16-27-98.21,11.82A7.77,7.77,0,0,0,464,184.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.44,241.94l-5.23,26.55h-6.94l2.73-14-8.84,11.38h-3.3L431,254.5l-2.8,14h-6.91l5.31-26.55h6.11L439,257.3,451,241.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483,247.93l-4.1,20.56h-6.83l.42-1.93a8.41,8.41,0,0,1-5.95,2.27c-4.44,0-8.69-3.37-8.69-9.37,0-6.82,5-11.87,11.15-11.87,2.77,0,5,.84,6.3,2.81l.49-2.47Zm-9.07,9.37a3.63,3.63,0,0,0-3.9-3.94c-2.85,0-4.9,2.31-4.9,5.76a3.61,3.61,0,0,0,3.91,3.91C471.93,263,473.94,260.72,473.94,257.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499,258.29l5.57,10.2h-7.66l-2.81-5.38-5,5.38H481L491.28,258l-5.43-10h7.55l2.73,5.24,4.9-5.24H509Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.49,264.89a4.47,4.47,0,0,1,4.63-4.59,3.79,3.79,0,0,1,4,3.94,4.48,4.48,0,0,1-4.59,4.59A3.88,3.88,0,0,1,506.49,264.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.82,288.35h8.29l-.4,2.06H454.8l.33-1.61,8.07-6.46c2.23-1.8,2.89-2.89,2.89-4.24s-1-2.39-3.24-2.39a5.92,5.92,0,0,0-4.29,1.84L457,276.18a8.3,8.3,0,0,1,6.2-2.54c3.36,0,5.28,1.71,5.28,4.15,0,1.92-.83,3.58-3.67,5.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475,275.89l-1.37,4.55h1.61c4.24,0,6.16,1.75,6.16,4.43,0,3.43-2.82,5.73-7.06,5.73a7.78,7.78,0,0,1-5.8-2.08l1.25-1.83a6.23,6.23,0,0,0,4.72,1.8c2.86,0,4.52-1.25,4.52-3.36,0-1.63-1.18-2.63-4.21-2.63h-4l2.58-8.67h9.36l-.41,2.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.67,284.51c0-5.75,3.25-10.87,8.39-10.87,3.48,0,5.59,2.25,5.59,6.09,0,5.76-3.27,10.87-8.36,10.87C485.78,290.6,483.67,288.35,483.67,284.51Zm11.61-4.73c0-2.63-1.28-4-3.41-4-3.74,0-5.83,4.86-5.83,8.72,0,2.63,1.28,4,3.44,4C493.19,288.49,495.28,283.64,495.28,279.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "613.94 453.52 618.19 460.38 629.01 447.88 623.31 441.83 613.94 453.52",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.05,446.6a9.9,9.9,0,0,1-1.45,1.93c-1,1.14-2.33,2.67-3.88,4.33l-4,4.22a11.26,11.26,0,0,1-1.74,1.67,11.08,11.08,0,0,1,1.46-1.92c1-1.14,2.34-2.67,3.88-4.33l4-4.22A11.93,11.93,0,0,1,628.05,446.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.09,447.25a11.24,11.24,0,0,1,2.66,2.26,11.79,11.79,0,0,1,2.29,2.63,11.7,11.7,0,0,1-2.66-2.26A12.12,12.12,0,0,1,618.09,447.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "618.19 460.38 629.01 447.88 627.94 446.73 616.89 458.87 618.05 460.26",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M528.58,469.91l0-1.69,17.09.13,0,5.56-1,.06c-4.7.22-23.9.79-27-.11C514.09,472.85,528.58,469.91,528.58,469.91Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M539.5,473.75a5.43,5.43,0,0,1,2.2-3.36,6.06,6.06,0,0,1,4-1.12l0,4.42Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M521.5,471.58s-5.08,1.33-4.46,2.11,20.05.88,28.62.22l0-.35-22.66.06S522.49,471.62,521.5,471.58Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M545.91,473.55l-.3,0-.84,0-3.09.11c-2.61.07-6.22.13-10.21.11s-7.6-.1-10.21-.2l-3.09-.14-.84-.05-.29,0h1.13l3.09.07c2.62.07,6.22.13,10.21.15s7.59,0,10.21,0l3.09-.05h1.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523,473.87a6,6,0,0,0-.56-1.38,6.43,6.43,0,0,0-1-1.1,2.19,2.19,0,0,1,1.22,1A2,2,0,0,1,523,473.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528,471.53s-.28-.25-.53-.61-.4-.69-.35-.71.28.24.53.61S528.07,471.5,528,471.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.41,470.86s-.31-.13-.6-.38-.49-.48-.45-.52a1.49,1.49,0,0,1,.59.38C529.24,470.59,529.45,470.82,529.41,470.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.29,469.37a2.13,2.13,0,0,1-.89.1,2.21,2.21,0,0,1-.88-.09,1.93,1.93,0,0,1,.88-.1A2.08,2.08,0,0,1,530.29,469.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.6,468.32a1.92,1.92,0,0,1-1,.26,1.82,1.82,0,0,1-1-.13,5.47,5.47,0,0,1,1-.06A4.58,4.58,0,0,1,530.6,468.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.46,470.14a3,3,0,0,1-1.09,0,6.49,6.49,0,0,1-1.16-.24,3.3,3.3,0,0,1-.67-.26.54.54,0,0,1-.27-.32.39.39,0,0,1,.17-.4,2.11,2.11,0,0,1,2.48.55,1.91,1.91,0,0,1,.35.68c0,.18,0,.28,0,.28a2.55,2.55,0,0,0-.49-.87,2,2,0,0,0-.92-.57,1.8,1.8,0,0,0-1.31.08c-.17.11-.11.3.08.41a3.35,3.35,0,0,0,.62.25,9.13,9.13,0,0,0,1.12.28C527,470.11,527.46,470.11,527.46,470.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.18,470.19a.89.89,0,0,1-.12-.7,1.63,1.63,0,0,1,.3-.74,1.12,1.12,0,0,1,.92-.52.4.4,0,0,1,.33.47,1.12,1.12,0,0,1-.19.46,3.25,3.25,0,0,1-.52.61,1.65,1.65,0,0,1-.63.41s.22-.18.52-.5a4,4,0,0,0,.47-.61c.15-.22.25-.6,0-.65s-.55.23-.72.43a1.49,1.49,0,0,0-.32.66A2.57,2.57,0,0,0,527.18,470.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.6,469.22s-.49,0-1.26,0a5.77,5.77,0,0,0-2.75,1,5,5,0,0,0-1.73,2.25c-.27.67-.3,1.13-.34,1.12a.87.87,0,0,1,0-.32,4.1,4.1,0,0,1,.2-.85,5,5,0,0,1,1.74-2.35,5.56,5.56,0,0,1,2.87-1,5.2,5.2,0,0,1,.94,0A1.24,1.24,0,0,1,545.6,469.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.37,472.2a14.81,14.81,0,0,1-5,0c0-.06,1.11,0,2.48,0S537.36,472.15,537.37,472.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.7,472.21s-.09.22-.21.46-.17.44-.23.44-.09-.25,0-.52S540.67,472.18,540.7,472.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542,470.77s-.07.2-.25.36-.35.27-.39.23.07-.2.25-.36S541.93,470.73,542,470.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.78,470.11c0,.05-.24.05-.49.13s-.43.21-.48.17.1-.25.41-.35S543.8,470.06,543.78,470.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.06,469.8c0,.05-.08.13-.22.18s-.27.06-.29,0,.08-.13.22-.18S545,469.76,545.06,469.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.55,247.8l-26.39-26.74,3.35-34.83.6-.69c.33-.38.7-.8,1.14-1.26A6.59,6.59,0,0,1,502,183a10.45,10.45,0,0,1,2.52-1c.83-.11,1.1-1.16.44-1.51s-2.94-.08-5.22,1.36-.89-2.51-.42-4,1.75-6,1.41-6.49c-.48-.71-1.36-.31-1.81,1.14s-2.08,5.75-2.84,5.48,1.79-7.62,1.79-7.62.8-1.48-.07-1.82c-1.56-.62-3.67,7.38-3.86,8.14-.12.53-1,.27-.79-.29s2.7-7.28,1.11-7.92c-1.21-.49-1.8,6.56-3.1,7.68s1-5.31-.18-5.73c-.44-.16-.8-.22-1.58,3.65a77.88,77.88,0,0,0-1.5,8.08h0l-8.3,41.61,26,34.39Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535,171.24c-1.09.62,2.32,6.54.84,5.68s-3.32-7.71-4.42-7c-1.45.92,2.24,7.05,2.51,7.59s-.51.94-.73.43c-.32-.72-3.83-8.2-5.25-7.32-.79.49.26,1.81.26,1.81s3.8,6.78,3.12,7.17-3.07-3.5-3.78-4.88-1.63-1.59-2-.8c-.24.54,1.82,4.79,2.55,6.13s2.79,5,.29,4-4.79-.86-5.37-.4-.13,1.44.7,1.4a10.3,10.3,0,0,1,2.66.54,6.45,6.45,0,0,1,2,1c.51.37.95.72,1.34,1l.72.57,14.26,35.16-12.95,30.15,20.08,7.48,9-39.88-20.69-38.8h0a76.6,76.6,0,0,0-2.93-7.67C535.75,170.89,535.41,171,535,171.24Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.8,384.87l-13-67.1-18.42,1.59v-.16l-33.64,3.05s-1.58,77.06-2.14,77.06l9.22,70.25h0l26.56-1.21-10.26-69.93,3.78-56.11.76-1L558,398.66l52.33,59.22,17-16.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.79,387.83a2.34,2.34,0,0,1,0-.58c0-.43,0-1,.06-1.64.07-1.49.18-3.53.31-6,.32-5.15.76-12.14,1.24-19.87.49-7,.94-13.42,1.28-18.32v-.06l0,0,4.61-5.48,1.28-1.47c.3-.34.46-.51.48-.49a4,4,0,0,1-.39.56l-1.2,1.54L542,341.54l0-.11c-.31,4.9-.71,11.31-1.15,18.32-.54,7.73-1,14.71-1.39,19.86-.2,2.49-.36,4.52-.48,6-.07.66-.12,1.2-.16,1.63A2.26,2.26,0,0,1,538.79,387.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.34,319.2a39,39,0,0,1,.26,6.42,39,39,0,0,1-.26,6.42,79.39,79.39,0,0,1,0-12.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.66,325a3.68,3.68,0,0,1,.83-.14l2.45-.29c2.13-.25,5.2-.59,8.88-1l.25,0v.25c0,3.16,0,6.79,0,10.66v.16l-.14.07-.19.09L531.35,338l-.13.06-.11-.07-5.56-3.29-.1-.07v-.11c0-2.85.08-5.22.1-7l.06-1.88a2.69,2.69,0,0,1,0-.63,6.34,6.34,0,0,1,.05.71c0,.51,0,1.15,0,1.93,0,1.72.06,4.05.11,6.85l-.11-.19,5.6,3.23h-.23l6.41-3.18.19-.1-.15.24c0-3.87,0-7.5,0-10.66l.26.23c-3.6.32-6.62.56-8.77.72l-2.51.18A9,9,0,0,1,525.66,325Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.56,322.48a4.28,4.28,0,0,1,.83-.13l2.45-.3c2.13-.25,5.2-.59,8.88-1l.25,0v.26c0,3.15,0,6.79,0,10.65v.16l-.15.07-.19.1-6.42,3.16-.12.05-.12-.06-5.56-3.3-.1-.06V332c0-2.85.08-5.22.11-7l0-1.89a2.8,2.8,0,0,1,0-.63,6.64,6.64,0,0,1,.05.71c0,.52,0,1.15,0,1.93,0,1.72.06,4.05.11,6.85l-.11-.18,5.6,3.23H557l6.41-3.18.19-.09-.15.23c0-3.86,0-7.5,0-10.65l.25.23c-3.6.32-6.62.56-8.77.72l-2.51.18A7.21,7.21,0,0,1,551.56,322.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.08,326.5a74.4,74.4,0,0,1-12.42.58,36.51,36.51,0,0,1,6.2-.55A37.78,37.78,0,0,1,538.08,326.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.75,324.14a73.28,73.28,0,0,1-12.19.93,35.36,35.36,0,0,1,6.07-.73A37.1,37.1,0,0,1,563.75,324.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536,397.83a70.87,70.87,0,0,1-12.08,1.48A70.87,70.87,0,0,1,536,397.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.12,386.32c0,.15-2.88,1.17-6.19,3s-5.72,3.79-5.83,3.67a6.8,6.8,0,0,1,1.49-1.39,30.22,30.22,0,0,1,4.09-2.74,30.63,30.63,0,0,1,4.47-2A6.36,6.36,0,0,1,578.12,386.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.55,154a3.52,3.52,0,0,1-.19-.37l-.54-1.1c-.23-.48-.5-1.1-.86-1.79l-1.3-2.39c-.5-.88-1.13-1.83-1.78-2.89s-1.48-2.13-2.34-3.29a63,63,0,0,0-6.61-7.28A57.86,57.86,0,0,0,486,122.1a52.53,52.53,0,0,0-14.86-2.41,57.57,57.57,0,0,0-30.94,8.23,53.25,53.25,0,0,0-11.7,9.49,58,58,0,0,0-12.68,22A63.91,63.91,0,0,0,413.7,169c-.17,1.43-.3,2.78-.39,4s-.12,2.37-.11,3.39,0,1.92.06,2.71.11,1.45.14,2,.07.92.09,1.22a3.31,3.31,0,0,1,0,.42,2.77,2.77,0,0,1-.07-.41c0-.3-.08-.71-.13-1.22s-.15-1.2-.2-2-.06-1.7-.1-2.72,0-2.16.06-3.41.19-2.59.35-4a62.3,62.3,0,0,1,2-9.68,58.06,58.06,0,0,1,12.68-22.21,53.13,53.13,0,0,1,11.79-9.59,57.76,57.76,0,0,1,31.21-8.31,53,53,0,0,1,15,2.46,58,58,0,0,1,22.05,13,62.93,62.93,0,0,1,6.59,7.37c.86,1.18,1.63,2.29,2.32,3.34s1.26,2,1.75,2.92l1.26,2.42c.35.7.6,1.32.82,1.82s.37.85.49,1.12A2.7,2.7,0,0,1,521.55,154Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.24,151.24a3.28,3.28,0,0,1-.47-.59c-.3-.4-.69-1-1.28-1.76a50.5,50.5,0,0,0-5.3-6,49.83,49.83,0,0,0-9.4-7.12,47.81,47.81,0,0,0-27.74-6.55,50,50,0,0,0-11.59,2.16,50.71,50.71,0,0,0-7.41,3c-.85.39-1.48.77-1.93,1a4.84,4.84,0,0,1-.69.33,3.66,3.66,0,0,1,.64-.42c.43-.25,1-.66,1.89-1.08a45.44,45.44,0,0,1,7.38-3.14,48.38,48.38,0,0,1,49.11,11.6,45.78,45.78,0,0,1,5.2,6.1c.57.76.93,1.4,1.21,1.82A6.75,6.75,0,0,1,510.24,151.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.84,268.54l-4.65,24.17c9.69,13.48,10.57,25,10.57,25l-52.06,4.48c1-8.17,6-25.84,6-25.84l-7.56-25.8L498,250.86l15-13.54c-.29.76,14.09,9.08,14.09,9.08l20.66.18a16.71,16.71,0,0,1,3,.59L560.84,221s7.8,11.48,5.19,25.57c-1.87,10-1.51,12.37-5.19,22",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.08,250.18a4.2,4.2,0,0,1,.76.9,15,15,0,0,1,1.56,2.84,13.82,13.82,0,0,1,1,4.7,11.86,11.86,0,0,1-1.23,5.77,10.25,10.25,0,0,1-4,4.34,9.44,9.44,0,0,1-4.66,1.25,8.18,8.18,0,0,1-3.18-.61,5,5,0,0,1-.79-.41c-.17-.1-.26-.17-.25-.18a10.37,10.37,0,0,0,4.22.83,9.48,9.48,0,0,0,4.42-1.29,10.08,10.08,0,0,0,3.77-4.16,11.71,11.71,0,0,0,1.22-5.52,14.2,14.2,0,0,0-.9-4.58A29.35,29.35,0,0,0,523.08,250.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.05,267.78c-.09,0,.36-1,.8-2.59a18.78,18.78,0,0,0-1-12.67c-.69-1.52-1.28-2.38-1.21-2.43s.2.18.49.56a11.6,11.6,0,0,1,1,1.71,17.15,17.15,0,0,1,1.8,6.37,17,17,0,0,1-.77,6.57,11.41,11.41,0,0,1-.76,1.86C559.22,267.58,559.08,267.8,559.05,267.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M552.07,291.26A2.07,2.07,0,0,0,550,291a15.78,15.78,0,0,1-3.5.72c-2.23.05-4.24-1.21-6.3-2.07s-4.67-1.24-6.3.28a3.59,3.59,0,0,0-.53,4.46,3.5,3.5,0,0,0,2.18,1.42h0c5.2,1.47,9.67.39,14.76-1.65a3.84,3.84,0,0,0,1.67-1.05A1.45,1.45,0,0,0,552.07,291.26Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M513.87,237.12a14.06,14.06,0,0,0-3.21,9.73c.34,3.48,2.7,6.86,6.08,7.76,2.32.61,4.85.06,7.12.83,4.19,1.41,6.41,6.9,10.82,7.29,4,.36,6.89-3.67,10.61-5.15a28.79,28.79,0,0,1,6.09-1.18c4.23-.69,8.39-2.73,10.86-6.23s2.87-8.6.3-12c-2.75-3.66-7.85-4.56-12.42-4.56a52.21,52.21,0,0,0-20.22,4.08,12.77,12.77,0,0,0-3.84,2.25,5.22,5.22,0,0,0-1.83,3.94"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M573.4,234.35a5.18,5.18,0,0,0-3.24-4.13c-2-.77-4.36-.22-6.32-1.09-2.45-1.09-3.48-4-4.1-6.57s-1.21-5.49-3.32-7.14c-1.46-1.14-3.39-1.48-5-2.46-2.33-1.43-3.6-4.05-5.19-6.28a12.57,12.57,0,0,0-2.13-2.31l-.09-.13c-3.39-4.08-12.42-4.61-16.32-1l.15-.14c-7.28.55-11.9,12.31-12,19.76,0,4.64,1.45,9.49-.3,13.78-1,2.5-3.06,4.51-3.84,7.09a7.88,7.88,0,0,0,13.85,7c-.11,1.89,1.45,3.56,3.23,4.2a13.27,13.27,0,0,0,5.62.34c4-.33,8.7-1,10.77-4.51,1.39,2.09,4.12,2.94,6.62,2.76a20.25,20.25,0,0,0,7.12-1.46,3.54,3.54,0,0,1-.26-.41,6.69,6.69,0,0,0,1.08-.52c1.92-1.17,3.11-3.71,2.21-5.78l2.18,2.53a8.7,8.7,0,0,0,3.64-11,10.58,10.58,0,0,1,3.43,2.29A5.21,5.21,0,0,0,573.4,234.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.48,237.45a3.6,3.6,0,0,0-.47-2.36,4.85,4.85,0,0,0-2.11-1.87,11.71,11.71,0,0,0-3.71-.86,15.09,15.09,0,0,1-4.64-1,5.59,5.59,0,0,1-2.12-1.67,8.23,8.23,0,0,1-1.29-2.54c-.62-1.84-.76-3.87-1.37-5.8a8.73,8.73,0,0,0-1.36-2.73A4.42,4.42,0,0,0,552.9,217c-1-.25-2.12-.23-3.21-.45a5.18,5.18,0,0,1-2.86-1.55c-1.52-1.57-2.12-3.59-2.79-5.34a11.85,11.85,0,0,0-2.69-4.51,10.66,10.66,0,0,0-10.43-2.87,21.24,21.24,0,0,0-2.34.83,3.16,3.16,0,0,1,.56-.34,9.84,9.84,0,0,1,1.73-.69,10.77,10.77,0,0,1,6.78.2,11,11,0,0,1,4,2.56,12,12,0,0,1,2.84,4.65c.68,1.77,1.29,3.71,2.71,5.15a4.7,4.7,0,0,0,2.59,1.41c1,.2,2.11.17,3.23.45a5,5,0,0,1,2.8,1.84,8.82,8.82,0,0,1,1.43,2.9c.63,2,.75,4,1.35,5.8a6.06,6.06,0,0,0,3.13,4,14.78,14.78,0,0,0,4.5,1,11.63,11.63,0,0,1,3.8,1,4.89,4.89,0,0,1,2.15,2,3.35,3.35,0,0,1,.44,1.82A2.07,2.07,0,0,1,572.48,237.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.7,251.86s.21-.09.55-.33a2.73,2.73,0,0,0,1-1.46,3.89,3.89,0,0,0-.17-2.78,6.74,6.74,0,0,0-2.65-2.66c-1.2-.76-2.68-1.33-4.14-2.26a7.72,7.72,0,0,1-2-1.78A7.48,7.48,0,0,1,551,238a42.32,42.32,0,0,1-.77-6c-.25-2-.87-4.19-2.65-5.42s-4-1.58-5.59-3.2a10.38,10.38,0,0,1-2.43-5.53c-.31-1.9-.44-3.71-.87-5.33a12.29,12.29,0,0,0-2-4.16,13.21,13.21,0,0,0-5.25-4.15c-1.48-.61-2.37-.73-2.36-.79a2.82,2.82,0,0,1,.64.08,10.89,10.89,0,0,1,1.8.53,12.91,12.91,0,0,1,5.46,4.11,12.4,12.4,0,0,1,2.13,4.27c.46,1.66.6,3.49.93,5.35a9.86,9.86,0,0,0,2.32,5.27c1.39,1.47,3.64,1.83,5.53,3.13a6.06,6.06,0,0,1,2.07,2.64,11.87,11.87,0,0,1,.78,3.13,41.91,41.91,0,0,0,.72,5.91,6.86,6.86,0,0,0,1.15,2.42,7.26,7.26,0,0,0,1.89,1.7c1.4.91,2.88,1.51,4.11,2.31a6.87,6.87,0,0,1,2.71,2.85,4,4,0,0,1,.1,3,2.83,2.83,0,0,1-1.14,1.48A1.67,1.67,0,0,1,559.7,251.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.55,254.05a3.46,3.46,0,0,0,.66-2,5.71,5.71,0,0,0-.52-2.38c-.38-.89-1-1.82-1.52-3a5.93,5.93,0,0,1-.42-4,21.93,21.93,0,0,1,1.84-4.28,10,10,0,0,0,1.31-4.76,8.3,8.3,0,0,0-1.75-4.93c-1.1-1.48-2.46-2.73-3.53-4.19a9.55,9.55,0,0,1-1.3-2.33,9.34,9.34,0,0,1-.51-2.51,20.37,20.37,0,0,1,.36-4.65,38.69,38.69,0,0,0,.57-4,9.26,9.26,0,0,0-1.06-5.55,8.17,8.17,0,0,0-1.35-1.62,1.75,1.75,0,0,1,.46.32,5,5,0,0,1,1.06,1.19,9.18,9.18,0,0,1,1.26,5.68,40.2,40.2,0,0,1-.51,4,19.73,19.73,0,0,0-.31,4.54,8.64,8.64,0,0,0,.5,2.38,9.1,9.1,0,0,0,1.24,2.2c1,1.4,2.4,2.64,3.54,4.18a8.83,8.83,0,0,1,1.84,5.23,10.5,10.5,0,0,1-1.39,5,22.42,22.42,0,0,0-1.85,4.18,5.52,5.52,0,0,0,.34,3.79c.49,1.11,1.08,2.07,1.45,3a5.82,5.82,0,0,1,.45,2.51,3.12,3.12,0,0,1-.48,1.53A1.61,1.61,0,0,1,535.55,254.05Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518,253.23a1.16,1.16,0,0,1-.29-.48,2.47,2.47,0,0,1,0-1.62,4.36,4.36,0,0,1,1.52-2.06,21.9,21.9,0,0,0,2.56-2.11,6.9,6.9,0,0,0,1.64-3.53,8.09,8.09,0,0,0-.71-4.43,10.33,10.33,0,0,1-1-5.11,17.81,17.81,0,0,1,1.9-5.25,11,11,0,0,0,1.34-5.18,22.42,22.42,0,0,0-1.08-5,15.18,15.18,0,0,1-.24-8.72,9.82,9.82,0,0,1,3.26-4.89,7.64,7.64,0,0,1,1.36-.86,1.93,1.93,0,0,1,.53-.2A14.67,14.67,0,0,0,527,205a9.87,9.87,0,0,0-3,4.84,15.07,15.07,0,0,0,.35,8.48,22,22,0,0,1,1.13,5.07,11.3,11.3,0,0,1-1.38,5.43,18.06,18.06,0,0,0-1.86,5.09,9.87,9.87,0,0,0,1,4.88,12.5,12.5,0,0,1,.69,2.34,7,7,0,0,1,0,2.32,7.2,7.2,0,0,1-1.8,3.71,19,19,0,0,1-2.65,2.09,4.3,4.3,0,0,0-1.51,1.9,2.44,2.44,0,0,0-.11,1.52C517.93,253.06,518.05,253.22,518,253.23Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105,446.88a2.13,2.13,0,0,1,.18-.44l.59-1.27a31.46,31.46,0,0,0,1.75-5.06c1.15-4.5,1.55-11.37-.15-19.54a104.6,104.6,0,0,0-3.63-13.12c-1.53-4.66-3.31-9.6-4.77-14.94a57.78,57.78,0,0,1-2.35-17.18c.22-6.08,2-12.15,4-18.18s4-12,4.62-17.91A27.24,27.24,0,0,0,102,322.71c-2.62-4.83-5.91-8.95-8.38-13.23a46.26,46.26,0,0,1-5-12.71,47.29,47.29,0,0,1-.31-19.7,36.81,36.81,0,0,1,2-7,2.7,2.7,0,0,1-.12.46l-.42,1.34a50.27,50.27,0,0,0-1.27,5.2A47.94,47.94,0,0,0,89,296.66a45.53,45.53,0,0,0,5,12.56c2.46,4.22,5.77,8.33,8.44,13.21a27.88,27.88,0,0,1,3.39,16.87c-.62,6.05-2.68,12-4.65,18s-3.75,12-4,18a57.61,57.61,0,0,0,2.3,17c1.43,5.31,3.19,10.26,4.71,14.93a101.68,101.68,0,0,1,3.56,13.2c1.66,8.23,1.19,15.17,0,19.68a29.46,29.46,0,0,1-1.86,5.06c-.28.52-.49.93-.65,1.24A3.72,3.72,0,0,1,105,446.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.93,313.7s-5-16,4-25.39a.55.55,0,0,1,1,.28C102.34,291.23,102.94,299.28,96.93,313.7Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.93,293.65a14.36,14.36,0,0,1-.34,3c-.33,2-.71,4.42-1.14,7.06s-.8,5-1.12,7.06a16.17,16.17,0,0,1-.53,2.93,12.69,12.69,0,0,1,.09-3c.16-1.83.49-4.35.94-7.11s.94-5.25,1.33-7A13.71,13.71,0,0,1,99.93,293.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.81,351.46s3.06-16.49,15.39-20.58a.55.55,0,0,1,.71.69C118.1,334.13,114.86,341.53,102.81,351.46Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.84,335.14a15.12,15.12,0,0,1-1.68,2.45l-4.31,5.71L104.56,349a15.56,15.56,0,0,1-1.84,2.33,12.4,12.4,0,0,1,1.47-2.58c1-1.54,2.47-3.62,4.16-5.85s3.28-4.2,4.46-5.6A13.9,13.9,0,0,1,114.84,335.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.48,392.84s-1.86-16.67,8.75-24.16a.55.55,0,0,1,.88.45C109.08,371.82,108.13,379.84,99.48,392.84Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.25,373.73a14.42,14.42,0,0,1-.89,2.83l-2.47,6.72c-.92,2.51-1.74,4.78-2.45,6.72a15.08,15.08,0,0,1-1.08,2.76,12.44,12.44,0,0,1,.66-2.9c.51-1.76,1.31-4.17,2.28-6.8s1.92-5,2.64-6.66A13.76,13.76,0,0,1,106.25,373.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.76,434.46s-1.26-16.73,9.61-23.83a.55.55,0,0,1,.86.48C119.1,413.79,117.87,421.78,108.76,434.46Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.21,415.6a14.2,14.2,0,0,1-1,2.81c-.78,1.9-1.7,4.14-2.71,6.62l-2.68,6.62a16.1,16.1,0,0,1-1.18,2.73,12.47,12.47,0,0,1,.76-2.88c.57-1.74,1.46-4.12,2.52-6.71s2.1-4.9,2.88-6.56A14.75,14.75,0,0,1,116.21,415.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.73,299.63s-14.87-7.77-15.16-20.75a.56.56,0,0,1,.87-.48C77.65,279.93,83.77,285.2,89.73,299.63Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.66,283.34a14.54,14.54,0,0,1,1.85,2.33l4.2,5.79,4.2,5.79a16,16,0,0,1,1.7,2.44,12,12,0,0,1-2-2.17c-1.18-1.41-2.73-3.42-4.36-5.69s-3.06-4.37-4-5.91A13.58,13.58,0,0,1,77.66,283.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.7,334s-15.31-6.85-16.39-19.79a.55.55,0,0,1,.83-.53C92.44,315.09,98.88,320,105.7,334Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.66,318.49a14.63,14.63,0,0,1,2,2.21c1.31,1.59,2.84,3.47,4.54,5.53l4.55,5.52a17.25,17.25,0,0,1,1.84,2.33,11.8,11.8,0,0,1-2.17-2c-1.26-1.33-2.94-3.24-4.71-5.41s-3.31-4.18-4.4-5.66A13.66,13.66,0,0,1,92.66,318.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.89,372.37s-10.51-13.07-5.58-25.08a.55.55,0,0,1,1-.09C93.71,349.48,97.21,356.76,96.89,372.37Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.35,352.61a15.08,15.08,0,0,1,.77,2.87c.43,2,.95,4.38,1.52,7s1.09,5,1.54,7a16.24,16.24,0,0,1,.57,2.91,11.82,11.82,0,0,1-1-2.8c-.52-1.76-1.14-4.22-1.73-7s-1-5.23-1.34-7A13.84,13.84,0,0,1,92.35,352.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.31,417.51s-15.2-7.11-16.06-20.06a.55.55,0,0,1,.84-.52C94.37,398.36,100.72,403.35,107.31,417.51Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.53,401.77a14.78,14.78,0,0,1,2,2.24l4.44,5.61,4.46,5.59a16,16,0,0,1,1.8,2.36A12.54,12.54,0,0,1,105,415.5c-1.23-1.36-2.88-3.3-4.61-5.49s-3.24-4.24-4.3-5.73A13.46,13.46,0,0,1,94.53,401.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.58,351.55a1.53,1.53,0,0,1,0,.37c0,.29,0,.64,0,1.07,0,1-.11,2.37-.18,4.07-.2,3.58-.47,8.56-.8,14.53h0v0c-1.09,6.07-4.18,12.8-8.33,19.33-3,4.81-6.24,9.19-9,13.26a93.09,93.09,0,0,0-6.75,11.14,47.81,47.81,0,0,0-3.15,8.18c-.27,1-.47,1.79-.58,2.32a3.77,3.77,0,0,1-.23.81,5.1,5.1,0,0,1,.1-.83c.08-.55.24-1.34.47-2.36a43.75,43.75,0,0,1,3-8.31,90,90,0,0,1,6.67-11.27c2.73-4.1,5.91-8.48,8.94-13.27,4.13-6.5,7.21-13.13,8.33-19.1v0c.42-6,.77-10.94,1-14.51.13-1.69.24-3.05.32-4.06,0-.42.08-.77.11-1.07S137.56,351.55,137.58,351.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.53,389.7s6.43-15.49-1.66-25.64a.55.55,0,0,0-1,.19C125.18,366.84,123.85,374.81,128.53,389.7Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.36,369.46a14,14,0,0,1,.51,2.93c.22,1.82.48,4.35.68,7.14s.29,5.33.29,7.16a12.33,12.33,0,0,1-.18,3,16.89,16.89,0,0,1-.26-3c-.14-2.06-.3-4.47-.48-7.14s-.35-5.08-.5-7.13A14.36,14.36,0,0,1,127.36,369.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M128.53,389.7s6.43-15.49-1.66-25.64a.55.55,0,0,0-1,.19C125.18,366.84,123.85,374.81,128.53,389.7Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M108.59,427s5.16-16-3.73-25.43a.56.56,0,0,0-1,.27C103.4,404.52,102.72,412.57,108.59,427Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.78,407a12.43,12.43,0,0,1,.75,2.88c.37,1.79.83,4.29,1.26,7.05s.72,5.29.87,7.12a11.55,11.55,0,0,1,.06,3,17.05,17.05,0,0,1-.5-2.93c-.3-2-.66-4.43-1-7.07s-.77-5-1.08-7.07A15.55,15.55,0,0,1,105.78,407Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M108.59,427s5.16-16-3.73-25.43a.56.56,0,0,0-1,.27C103.4,404.52,102.72,412.57,108.59,427Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M136.72,370.77s13.75-9.62,12.36-22.53a.55.55,0,0,0-.92-.36C146.16,349.68,140.77,355.69,136.72,370.77Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M136.72,370.77s13.75-9.62,12.36-22.53a.55.55,0,0,0-.92-.36C146.16,349.68,140.77,355.69,136.72,370.77Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M146.59,353.06a12.74,12.74,0,0,1-1.14,2.75c-.78,1.66-1.92,3.92-3.25,6.38s-2.61,4.66-3.59,6.21a12.34,12.34,0,0,1-1.75,2.41,16.2,16.2,0,0,1,1.36-2.64l3.43-6.27,3.41-6.29A15.07,15.07,0,0,1,146.59,353.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.13,411.21s16.58-2.58,21-14.78a.56.56,0,0,0-.67-.74C131.9,396.43,124.41,399.45,114.13,411.21Z",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M114.13,411.21s16.58-2.58,21-14.78a.56.56,0,0,0-.67-.74C131.9,396.43,124.41,399.45,114.13,411.21Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M130.8,399.66a13.28,13.28,0,0,1-2.24,2c-1.43,1.15-3.45,2.68-5.73,4.3s-4.39,3-6,4a12.29,12.29,0,0,1-2.63,1.4,14.85,14.85,0,0,1,2.39-1.77l5.83-4.13,5.83-4.14A14.68,14.68,0,0,1,130.8,399.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.32 441.72 93.49 474.26 123.62 474.26 119.71 441.72 98.32 441.72",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.92,451.8c0,.17-5.44.31-12.15.31s-12.15-.14-12.15-.31,5.43-.31,12.15-.31S120.92,451.63,120.92,451.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.51,454.39c0,.17-5.61.31-12.54.31s-12.55-.14-12.55-.31,5.61-.31,12.55-.31S121.51,454.22,121.51,454.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658,430.7a8.25,8.25,0,0,0-5,4.05,14.46,14.46,0,0,0-1.66,6.36c-.25,4.28,1.41,8.92,3.4,12.71,4.06-2.48,5.79-7.71,6.51-10.43,1.12-4.28.55-12.71-3.22-12.69",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.46,460a7,7,0,0,0-1.11-7,9.33,9.33,0,0,0-6.43-3.28,3.92,3.92,0,0,0-3.21.83,3,3,0,0,0-.56,3,6.13,6.13,0,0,0,1.85,2.57c2.73,2.45,5.82,4.31,9.46,3.87",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.79,473.67a6.11,6.11,0,0,0,0-.88c0-.63,0-1.44,0-2.41a24.76,24.76,0,0,0-1.13-7.85,15.14,15.14,0,0,0-4.36-6.58,10,10,0,0,0-2-1.34c-.25-.13-.46-.21-.6-.27l-.21-.06a15.86,15.86,0,0,1,2.68,1.83,15.53,15.53,0,0,1,4.22,6.53,26.42,26.42,0,0,1,1.2,7.75c.05,1,.09,1.83.13,2.4A4.53,4.53,0,0,0,651.79,473.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.9,437.16a2.18,2.18,0,0,0-.1.37l-.25,1.07c-.21.93-.5,2.28-.84,3.95-.69,3.34-1.57,8-2.42,13.1s-1.53,9.8-2,13.18c-.22,1.69-.38,3.06-.49,4,0,.45-.08.81-.11,1.09a1.17,1.17,0,0,0,0,.39,3.1,3.1,0,0,0,.08-.38c0-.28.1-.64.16-1.08.15-1,.35-2.34.59-4,.49-3.37,1.2-8,2.05-13.16s1.7-9.76,2.33-13.11c.31-1.65.56-3,.75-4,.08-.44.14-.8.19-1.08S657.92,437.16,657.9,437.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.13,463.64A16.49,16.49,0,0,1,666,453.27c1.28-.36,2.88-.46,3.7.58s.34,2.58-.35,3.72A14,14,0,0,1,655.16,464",
    style: {
      fill: "#FF822F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.77,457.15a4.18,4.18,0,0,0-.81.2,7.11,7.11,0,0,0-.92.31,11.64,11.64,0,0,0-1.19.49,12.4,12.4,0,0,0-1.39.72,14.59,14.59,0,0,0-1.52,1,18.51,18.51,0,0,0-3,2.78,17.6,17.6,0,0,0-2.28,3.43,16.21,16.21,0,0,0-.71,1.66,12.14,12.14,0,0,0-.48,1.49c-.14.46-.19.89-.27,1.26a7.16,7.16,0,0,0-.14,1,4.69,4.69,0,0,0,0,.83c.07,0,.15-1.17.67-3a14.29,14.29,0,0,1,.51-1.46,15,15,0,0,1,.72-1.62,17.4,17.4,0,0,1,5.24-6.11,16.23,16.23,0,0,1,1.48-1,13.23,13.23,0,0,1,1.35-.74C663.64,457.52,664.79,457.22,664.77,457.15Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessing);
export default __webpack_public_path__ + "static/media/processing.3b6aa30ee0a72f6d0d9b9992c58f85df.svg";
export { ForwardRef as ReactComponent };